/**
 * browser DB transaction step を順番に実行し、各 step が返す Promise 群を待機する。
 */

/**
 * transaction step 群を順番に実行する。
 * @param params 実行対象の step 群と transaction 用 database を受け取る。
 */
export const executeTransactionQuerySteps = async <
  TTransactionDatabase,
>(params: {
  readonly querySteps: readonly ((
    transactionDatabase: TTransactionDatabase,
  ) => readonly Promise<unknown>[])[]
  readonly transactionDatabase: TTransactionDatabase
}): Promise<void> => {
  const { querySteps, transactionDatabase } = params

  for (const queryStep of querySteps) {
    await Promise.all(queryStep(transactionDatabase))
  }
}
